import React from 'react';

interface IProps {
  fillColor?: string;
}

const RemoveIcon:React.FC<IProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" fill="none" viewBox="0 0 23 22">
      <path fill={props.fillColor ? props.fillColor : "#122442"} fillRule="evenodd" d="M10.1 12l-4.6 4.6L6.9 18l4.8-4.8 4.8 4.8 1.4-1.4-4.6-4.6 4.6-4.6L16.5 6l-4.8 4.8L6.9 6 5.5 7.4l4.6 4.6z" clipRule="evenodd"/>
    </svg>
  )
}

export default RemoveIcon;